import {topDestinationsApiConfig, __VOYAGER__, __VOYAGERX__, __MYPARTNER__} from '../../../config/api-config';

export const prepareDestinationsApiRequest = () => {
  let url = `${__VOYAGERX__}`;
  url += `/api/${topDestinationsApiConfig.version}/hotels/get_home_page_data/`;
  return url;
};

export const prepareCampaignApiRequest = (campaignData) => {
  let url = `${__MYPARTNER__}`;
  url += `/common/get_campaign_location?agent_city=${campaignData.city}&agent_state=${campaignData.state}`;
  return url;
}
